import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2mlu5ue0ah7o0">
      <MetaPixel data-id="element-1" data-mp="2mjznn7gejtnm" />
      <Hero data-id="element-2" data-mp="31agoopp4khjz" />
      <StatsAndProof data-id="element-3" data-mp="31ayry6a7fw1e" />
      <PainPoints data-id="element-4" data-mp="31bi9hlvy0iew" />
      <ProductOffer data-id="element-5" data-mp="31c1jmgfcq2id" />
      <Pricing showAnchor data-id="element-6" data-mp="31cjjro54x0vk" />
      <ExtendedTestimonials data-id="element-7" data-mp="2wjgq7g0cxrfd" />
      <GuaranteeAndFaq data-id="element-8" data-mp="2wj8g1vvmd07v" />
      <CostSection data-id="element-9" data-mp="2whxb3sqftmf6" />
      <Pricing data-id="element-10" data-mp="28ufoscpxzgjl" />
      <FooterAndProofPopup data-id="element-11" data-mp="28tw4wqgqei2x" />
    </main>;
}